import { render, staticRenderFns } from "./StartupEditPatents.vue?vue&type=template&id=73b36304&scoped=true"
import script from "./StartupEditPatents.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditPatents.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b36304",
  null
  
)

export default component.exports